"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .rating {
        --star-width: 36px;
        display: flex;
        justify-content: var(--rating-options-position);
    }

    .rating__container {
        --rating-stars-free-space: calc(
            (100vw - var(--page-horizontal-padding) - var(--star-width) * var(--stars)) /
                (var(--stars) - 1)
        );
        text-align: start;
        white-space: nowrap;
        display: flex;
        justify-content: var(--rating-justify-content);
        flex: 1;
        gap: clamp(0px, var(--rating-stars-free-space), var(--rating-gap));
        max-width: var(--rating-options-max-width);
    }

    .rating_starType_portal {
        --star-width: 32px;
    }

    .rating_starType_portal.rating_isMany {
        --star-width: 24px;
    }

    .rating__wrapper {
        all: unset;
        --calc-margin-star: calc(var(--rating-stars-free-space) / 2);
        display: table-cell;
        width: 3.6em;
        position: relative;
        margin: 0 min(0px, var(--calc-margin-star));
    }

    .rating__wrapper:before {
        content: '';
        display: inline-block;
        padding-top: 100%;
    }
    .rating__option {
        cursor: pointer;

        & span {
            display: none;
        }

        & + & {
            margin-inline-end: 0.3em;
        }
    }
    .rating__wrapper:has(.rating__input:focus-visible) {
        border-radius: 4px;
        outline: 2px solid var(--rating-focus-visible-border-color);
        outline-offset: 2px;
    }

    .rating__input {
        opacity: 0;
        height: 0;
        width: 0;
        position: absolute;
        left: -10000px;
    }

    .rating__option path {
        stroke: var(--rating-border-inactive);
        fill: var(--rating-fill-inactive);
        fill-opacity: 1;
    }

    /* Подсвечивает звезду, на которую навели курсор и подсвечивает все предыдущие неактивные звезды */
    .rating__wrapper:hover .rating__option:not(.rating__option_active) path,
    .rating__wrapper:has(~ .rating__wrapper:hover):not(:has(.rating__option_active))
        .rating__option
        path {
        stroke: var(--rating-border-inactive-hover);
        fill: var(--rating-fill-inactive-hover);
    }

    .rating__option svg {
        overflow: visible;
    }

    .rating__option_active path,
    .rating__option_active ~ .rating__option path {
        stroke: var(--rating-border-active);
        fill: var(--rating-fill-active);
    }

    .rating__noop-answer {
        margin-top: 1.5em;
    }

    .rating_stars_2 {
        --stars: 2;
    }
    .rating_stars_3 {
        --stars: 3;
    }
    .rating_stars_4 {
        --stars: 4;
    }
    .rating_stars_5 {
        --stars: 5;
    }
    .rating_stars_6 {
        --stars: 6;
    }
    .rating_stars_7 {
        --stars: 7;
    }
    .rating_stars_8 {
        --stars: 8;
    }
    .rating_stars_9 {
        --stars: 9;
    }
    .rating_stars_10 {
        --stars: 10;
    }

    .rating_stars_2 .rating__container {
        max-width: var(--rating-options-count-2-max-width);
    }

    .rating_stars_3 .rating__container {
        max-width: var(--rating-options-count-3-max-width);
    }

    /* Стили transparent */

    .question_theme_transparent .rating {
        text-align: center;
        display: inline-block;

        &__wrapper {
            width: 3em;
        }

        &__option {
            height: 85%;
            width: 93%;
            background-image: url(data:image/svg+xml;base64,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);

            & + .rating__option {
                margin-inline-end: 0.5em;
            }

            &.rating__option_active {
                background-image: url(data:image/svg+xml;base64,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);
            }
        }
    }
`;
